import { RTC_DIRECTION } from '~/lib/constants'

export default {
	rtc_direction: RTC_DIRECTION,
	rtc_state: 'disconnected',
	dc_state: 'closed', // Data channel state: 'connecting' | 'open' | 'closing' | 'closed'
	// Bumped every time a peer connection is built. Transceivers don't survive a rebuild, so anything holding a sender (e.g. the microphone) must re-attach when this changes.
	pc_generation: 0,
	ably_state: 'disconnected',
	// A phone's 'camera' | 'remote', resolved once per load before WebRTC starts (`src/lib/clientMode.js`); null on a desktop or until resolved.
	client_mode: null,
	control_mode: 'ctl_depth',
	presence: [],
	session_presence: [],
	active_device: null, // deprecated, use source_device
	source_device: null,
	// The one desktop that runs automation and autoplay (server-chosen, newest desktop wins). `runner_supported` false: the server names no runner, so this client runs its own.
	runner_device: null,
	runner_supported: false,
	dc_connections: [],
	output_devices: [],
	output_devices_received: false,
	pending_outputs: [],
	project_id: null,
	is_template: false,
	is_examples: null,
	show_stats: false,
	// The server's latest network notices (src/lib/networkNotice.js): per direction for this client, and about the input device.
	network_quality: { down: null, up: null },
	source_quality: null,
	session_state: {
		control_mode: null,
		upscale: null,
	},
	session_loading: {
		progress: 0,
		last_changed: 0,
	},
	// `history` is most-recently-used order; `browse` is the prev/next cursor, null when not browsing.
	prompt: {
		history: [],
		browse: null,
	},
	advanced_controls: [],
	virtual_camera_state: null,
	video_quality: {
		bitrate_mbps: 0,
		quality_level: null,
	},
	stats: {
		framerate: {
			in_fps: null,
			out_fps: null,
		},
		video_quality: {},
	},
}
